import React, { useEffect } from "react";
import LoginForm from "@/components/pages/login/loginForm";
import { useSelector } from "react-redux";
import { navigate } from "gatsby";
import { AppStateType } from "@/reducers";
import * as cookieControls from "@/utils/cookieUtils";

const Login = () => {
  const { authtoken } = useSelector((state: AppStateType) => state.account);

  useEffect(() => {
    const cookie: string = cookieControls.get("authtoken");
    const hasToken: boolean = !!cookie && !!authtoken;
    const isEqual: boolean = cookie === authtoken;

    if (hasToken && isEqual) {
      navigate("/platform/");
    }
  }, [authtoken]);

  return (
    <>
      <LoginForm />
    </>
  );
};

export default Login;
